import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed grid grid-rows-5 grid-cols-5 grid-flow-col items-stretch h-screen w-screen z-40 justify-items-center bg-black bg-opacity-50"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "text-6xl material-icons text-white mr-2" }, "cancel", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "row-start-2 col-start-2 col-span-3 row-span-3 col-end-5 justify-center items-center font-mono text-2xl text-white" }
const _hoisted_5 = { class: "flex flex-col items-stretch md:items-center" }
const _hoisted_6 = { class: "my-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "col-start-5 row-span-1 col-span-1 flex justify-center items-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShow = false)),
          id: "CloseGuideLogin"
        }, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("message.guidesignin")), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoLogin && _ctx.gotoLogin(...args))),
              id: "tryNow",
              class: "bg-green-800 hover:bg-green-100 text-white md:w-2/3 justify-center font-semibold py-2 px-4 border border-gray-400 rounded shadow"
            }, _toDisplayString(_ctx.$t("function.trynow")), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}